/**
 * Copyright (c) 2024-2026 Creative Agentics Limited. All rights reserved.
 * Proprietary and confidential.
 *
 * THE CLIENT'S LINE WHEN THE ANALYSIS IS COMPLETE (29/10/2026, owner decision).
 * The strip's finished line was the officer's sentence, word for word: "Analysis
 * complete: 27 documents read, registers, public records and adverse media
 * checked, 4 parties screened, ownership mapped, 10 points prepared for review".
 * It told the client which checks ran, and its count of points was the stored
 * list Alex covers, which can hold points never put to the client (withheld). The
 * client now reads one fixed sentence on every case type, with no check named and
 * no count; the officer keeps its own wording. The page reads the line from here
 * whatever the stored progress says, so a case finished before this change shows
 * the client line too.
 */
// While it runs, one fixed line in place of the officer's stage lines.
export const ANALYSIS_RUNNING_CLIENT_LINE = 'Reading your documents and preparing your file';
export const ANALYSIS_DONE_CLIENT_LINE = 'Thank you. We have read the documents provided and prepared a few questions to complete your file.';
export const ANALYSIS_PROVISIONAL_CLIENT_LINE = 'Your documents have been analysed. The compliance team will complete the review of your answers.';

/** The line the client sees for the finished entry of the analysis strip. */
export function analysisDoneClientLine(doneEntry) {
  const meta = (doneEntry && doneEntry.meta) || {};
  return meta.provisional ? ANALYSIS_PROVISIONAL_CLIENT_LINE : ANALYSIS_DONE_CLIENT_LINE;
}
